<section class="{{ isNRIPageCSS }}" *ngIf="cmsContent">
  <div class="book_free_demo_mb" *ngIf="cmsContent.isrightpanel == true && (this.userDetails == null || this.userDetails.undefine)">
    <a
      class="expand_box_btn"
      id="dvMobileCollapseLead"
      (click)="bookLiveClass()"
      [style.display]="showBookDemoLink ? 'inline' : 'none'"
      >Book a free demo of live class</a
    >
  </div>

  <div class="loader-overlay" *ngIf="isLoading">
    <div class="spinner">
      <div></div>
      <div></div>
    </div>
  </div>

  <div [class]="cmsContent.isrightpanel ? 'container' : 'nonRightPanelContainer'">
    <div class="container-fluid">
      <div class="row">
        <!--If CMS not contains Right panel-->
        <div class="col-lg-12" *ngIf="cmsContent.isrightpanel == false || cmsContent.isrightpanel == null">
          <div class="left_box cmsdata" *ngIf="cmsContent">
            <div
              (click)="getCMSDatahref($event)"
              (input)="onKeyDown($event)"
              [innerHtml]="cmsContent.content | noSanitizePipe : 'html'"
            ></div>
          </div>
          <div class="container" *ngIf="previousURL === '/careers.aspx'">
            <app-careersform></app-careersform>
          </div>
          <div class="container" *ngIf="previousURL === '/contact-us.aspx'">
            <app-contact-usform></app-contact-usform>
          </div>
        </div>

        <!-- If CMS content cnatains Rightpanel -->
        <div class="col-lg-8" style="margin-top: 0px" *ngIf="cmsContent.isrightpanel == true">
          <div class="left_box cmsdata" *ngIf="cmsContent">
            <div (click)="getCMSDatahref($event)" [innerHtml]="cmsContent.content | noSanitizePipe : 'html'"></div>
          </div>
        </div>

        <div class="col-lg-4 question-section">
          <div *ngIf="cmsContent.relatedLink">
            <app-sibling-link
              [relatedLink]="cmsContent.relatedLink"
            ></app-sibling-link>
          </div>
          <div *ngIf="cmsContent.isrightpanel == true">
            <app-registration
              [sourceId]="sourceId"
              [isCMS]="'cms'"
              [pageTitle]="pageTitle"
              *ngIf="previousURL !== '/careers.aspx' && (this.userDetails == null || this.userDetails.undefine)"
            ></app-registration>
            <app-cmsviewcourses *ngIf="previousURL !== '/careers.aspx'"></app-cmsviewcourses>
            <app-right-block
              [fromMyResourcehide]="false"
              *ngIf="previousURL !== '/careers.aspx'"
              [forum_page_right]="true"
              [NewGradeId]="gradeId"
            ></app-right-block>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bottom_link_strip" *ngIf="cmsContent.isrightpanel == true">
    <a class="bl_share_class" id="ancBookLiveClass" *ngIf="UserId">Share</a>
    <a (click)="bookLiveClass()" class="bl_class" id="ancBookLiveClass" *ngIf="!UserId">Book a Live class</a>
    <a routerLink="/package" routerLinkActive="active" class="bt_lcourses">Live courses</a>
    <a routerLink="/forums/" routerLinkActive="active" class="bt_aquestion">Ask question</a>
  </div>
</section>
